import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css', 
})
export class AppComponent implements OnInit {
  constructor() { }
  apiValues: string[] = [];
  ngOnInit() {
  }
}
